import { withTranslation } from '@wix/yoshi-flow-editor';

export default (Component) => withTranslation()(Component);
